import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { ClassifyFollowUpStepResult } from "@/types/classification";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import DebugInfoJsonViewer from "./DebugInfoJsonViewer";

export function FollowUpStepResultCard({ result }: { result: ClassifyFollowUpStepResult }) {
  const [expanded, setExpanded] = useState(false);

  if (!result) return null;

  return (
    <Card className="rounded-md border bg-muted/30">
      <CardHeader>
        <div className="flex items-center gap-2">
          <button
            className="flex items-center gap-2 w-full text-left focus:outline-none"
            onClick={() => setExpanded((prev) => !prev)}
            type="button"
          >
            {expanded ? <ChevronDown className="h-4 w-4 mr-2" /> : <ChevronRight className="h-4 w-4 mr-2" />}
            <span className="font-medium">Follow-Up Classification Step Result</span>
          </button>
        </div>
      </CardHeader>
      {expanded && (
        <CardContent className="space-y-4">
          {result.error && (
            <div className="rounded-md border-2 border-red-500 bg-red-50 p-4">
              <div className="font-medium text-red-800 mb-1">Error</div>
              <div className="text-sm text-red-600 whitespace-pre-wrap break-words">{result.error}</div>
            </div>
          )}
          <div>
            <div className="font-semibold mb-1">Is Follow-Up?</div>
            <span
              className={cn(
                "inline-block rounded-full px-3 py-1 text-sm font-medium",
                result.isFollowUp
                  ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100"
                  : "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-100",
              )}
            >
              {result.isFollowUp ? "Yes" : "No"}
            </span>
          </div>
          {result.debugInfo && (
            <div>
              <div className="font-semibold mb-1">Debug Info</div>
              <DebugInfoJsonViewer debugInfo={result.debugInfo} />
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}

export default FollowUpStepResultCard;
